module.exports = __webpack_public_path__ + "static/media/GraphMenu.70ebd6df.svg";